import { connect, useSelector } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import axios from "axios";
import {
  ALL_SUBSCRIPTION_PLANS_ENDPOINT,
  CREATE_CHECKOUT_SESSION_ENDPOINT,
  SHOW_MY_TEAM_MEMBERS,
  SUBSCRIPTION_ENDPOINT,
} from "../../../_actions/endpoints";
import { handleHTTPError } from "../../../_actions/errorHandlerActions";
import { syncWorkspaces } from "../../../_actions/authActions";
import { analyticsTrackEvent, isWorkspaceOwner } from "../../../_utils/common";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogCloseButton,
} from "@chakra-ui/react";

import { withTranslation } from "react-i18next";
import { showToast } from "apps/simplified-web/src/_utils/showToast";
import { useState } from "react";
import { useEffect } from "react";
import TldrUpgradePlanSelection from "../TldrUpgradePlanSelection";
import { useStripe } from "@stripe/react-stripe-js";
import TldrUpgradePlanCheckout from "../TldrUpgradePlanCheckout";
import TldrUpgradeTrialEndedSummary from "../TldrUpgradeTrialEndedSummary";
import {
  BILLING_PLAN_BUSINESS,
  BILLING_PLAN_INTERVAL_MONTHLY,
  BILLING_PLAN_INTERVAL_YEARLY,
} from "apps/simplified-web/src/_components/details/constants";
import { MY_ACCOUNT } from "apps/simplified-web/src/_utils/routes";

function TldrTrialEndedModal(props) {
  const [loading, setLoading] = useState(false);
  const [currentMember, setCurrentMember] = useState([]);
  const [upgradePlanStep, setUpgradePlanStep] = useState(
    props.showFeatures ? 1 : 2
  );

  const [resData, setResData] = useState({
    payload: [],
    loaded: false,
  });
  const [checked, setChecked] = useState(true);
  const [currentOrg, setCurrentOrg] = useState(0);

  const subscription = useSelector((state) => state.subscription);
  const auth = useSelector((state) => state.auth);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [cartData, setCartData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [updatingPlan, setUpdatinPlan] = useState(false);
  const stripe = useStripe();
  const history = useHistory();

  useEffect(() => {
    fetchSubscriptionPlans();
    getSelectedOrg();
    fetchCurrentMembers();
    return () => {
      axios.CancelToken.source();
    };
  }, []);

  function getSelectedOrg() {
    const { payload } = auth;
    const { orgs, selectedOrg } = payload;

    const org = orgs.filter((o) => o.id === selectedOrg)[0];
    setCurrentOrg(org);
  }

  function fetchCurrentMembers() {
    const { payload } = auth;

    axios
      .get(`${SHOW_MY_TEAM_MEMBERS}${payload.selectedOrg}/members`)
      .then((res) => {
        const member = res.data.results.filter(
          (o) => o.user_id === payload.user.pk
        )[0];
        setCurrentMember(member);
      })
      .catch((error) => {
        handleHTTPError(error);
      });
  }

  function fetchSubscriptionPlans() {
    axios
      .get(ALL_SUBSCRIPTION_PLANS_ENDPOINT)
      .then((res) => {
        setResData({
          payload: res.data.results,
          loaded: true,
        });
        const planName = props.selectedPlanName
          ? props.selectedPlanName
          : BILLING_PLAN_BUSINESS;
        const defaultPlanId =
          res.data.results.find(
            (item) =>
              item.product.name === planName &&
              item.recurring.interval === BILLING_PLAN_INTERVAL_YEARLY
          )?.id ||
          res.data.results.find(
            (item) =>
              item.product.name === BILLING_PLAN_BUSINESS &&
              item.recurring.interval === BILLING_PLAN_INTERVAL_YEARLY
          )?.id;
        setSelectedPlanId(defaultPlanId);
      })
      .catch((error) => {
        handleHTTPError(error);
        setResData({
          payload: null,
          loaded: false,
        });
      });
  }
  const fetchAllPlans = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(ALL_SUBSCRIPTION_PLANS_ENDPOINT)
        .then((res) => {
          resolve(res.data.results);
        })
        .catch((error) => {
          reject(error);
          handleHTTPError(error, this.props);
        });
    });
  };

  var filteredPlans = [];
  const paidPlans = resData.payload.slice(1, resData.payload.length);
  filteredPlans = paidPlans.filter((plan) => {
    if (checked) {
      return plan.recurring?.interval === BILLING_PLAN_INTERVAL_YEARLY;
    } else {
      return plan.recurring?.interval === BILLING_PLAN_INTERVAL_MONTHLY;
    }
  });

  const { subscribedPlan } = subscription;

  function getSelectedPlan(id, plans) {
    return plans.find((plan) => plan.id === id);
  }
  function getPlanIndex(id, plans) {
    return plans.findIndex((plan) => plan.id === id);
  }

  function handleStripeCheckoutForm(selectedPlan) {
    if (
      selectedPlan?.unit_amount > 0 &&
      (!subscribedPlan.customer ||
        !subscribedPlan?.customer?.payment_method?.card)
    ) {
      setUpdatinPlan(true);
      axios
        .post(CREATE_CHECKOUT_SESSION_ENDPOINT, {
          price: selectedPlan.id,
        })
        .then((res) => {
          analyticsTrackEvent("subscribed", {
            plan: selectedPlan.id,
            unit: selectedPlan.unit_amount,
          });
          setUpdatinPlan(false);
          if (res.data?.session_url) {
            window.location.href = res.data.session_url;
            return null;
          } else {
            stripe.redirectToCheckout({ sessionId: res.data.session_id });
          }
        })
        .catch((error) => {
          setUpdatinPlan(false);
          handleHTTPError(error);
        });
    }
  }

  const subscribeToFreePlan = () => {
    const { subscription, t } = props;
    const { subscribedPlan } = subscription;

    if (currentOrg?.members_count > 1) {
      return;
    }
    if (!currentMember?.is_admin && !currentMember?.is_primary) {
      return;
    }

    setLoading(true);

    fetchAllPlans().then((plans) => {
      axios
        .post(SUBSCRIPTION_ENDPOINT, {
          plan: plans[0].id,
          subscription_id: subscribedPlan.id,
        })
        .then((res) => {
          analyticsTrackEvent("subscribed", {
            plan: "free",
            unit: 0,
          });
          props.syncWorkspaces();
        })
        .then(() => {
          setLoading(false);
          props.onHide();

          showToast({
            description: t("generic.free_plan", { ns: "common" }),
            title: t("success", { ns: "common" }),
            status: "success",
          });
        })
        .catch((error) => {
          setLoading(false);
          props.onHide();
          showToast({
            description: t("errors.contact_support", { ns: "common" }),
            title: t("errors.failed_msg", { ns: "common" }),
            status: "error",
          });
          return;
        });
    });
  };

  const { show } = props;

  return (
    <AlertDialog
      autoFocus={false}
      isOpen={show}
      onClose={() => {
        !isWorkspaceOwner(auth.payload.user)
          ? history.push(MY_ACCOUNT)
          : props.onHide();
      }}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent
        minWidth={["0", "0", "0", "768px"]}
        borderRadius="lg"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          zIndex: 0,
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(50% 50% at 50% 50%, #13303E 0%, rgba(30, 30, 30, 0) 100%);",
        }}
      >
        <AlertDialogCloseButton zIndex="2" />
        <AlertDialogBody position="relative" zIndex="1" p="0">
          {upgradePlanStep === 1 && (
            <TldrUpgradeTrialEndedSummary
              onClose={props.onHide}
              setUpgradePlanStep={setUpgradePlanStep}
              subscribeToFreePlan={subscribeToFreePlan}
              currentMember={currentMember}
              currentOrg={currentOrg}
              loading={loading}
            />
          )}
          {upgradePlanStep === 2 && (
            <TldrUpgradePlanSelection
              showFeatures={props.showFeatures}
              setCartData={setCartData}
              setUpgradePlanStep={setUpgradePlanStep}
              setIsLoading={setIsLoading}
              cartData={cartData}
              onClose={() => props.onHide()}
              setChecked={setChecked}
              checked={checked}
              setSelectedPlanId={setSelectedPlanId}
              selectedPlanId={selectedPlanId}
              resData={resData}
              currentOrg={currentOrg}
              adminMember={currentMember}
              subscribeToFreePlan={subscribeToFreePlan}
              loading={loading}
            />
          )}

          {upgradePlanStep === 3 && (
            <TldrUpgradePlanCheckout
              setUpgradePlanStep={setUpgradePlanStep}
              handleStripeCheckout={handleStripeCheckoutForm}
              cartItems={cartData}
              isLoading={updatingPlan}
              onClose={() => props.onHide()}
              selectedPlan={getSelectedPlan(selectedPlanId, filteredPlans)}
              planIndex={getPlanIndex(selectedPlanId, filteredPlans)}
              yearlyInterval={checked}
            />
          )}
        </AlertDialogBody>
      </AlertDialogContent>
    </AlertDialog>
  );
}

const mapStateToProps = (state) => ({
  subscription: state.subscription,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  syncWorkspaces: () => dispatch(syncWorkspaces()),
  handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
});

export default withTranslation("accounts")(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TldrTrialEndedModal))
);
